import { Chip } from "@mantine/core";

export const chipComponentSettings = Chip.extend({
  defaultProps: {},
});
